module.exports = __webpack_public_path__ + "static/media/ru-MD.b293d647.md";